import { RuleType } from '../IRule';
import { CustomWarningsRule } from './custom-warnings/CustomWarnings.rule';
import { DateRangeRule } from './date-range/DateRange.rule';
import { FileTypeRule } from './file-type/FileType.rule';
import { IntegerRule } from './integer/Integer.rule';
import { ItemRangeRule } from './item-range/ItemRange.rule';
import { LengthRangeRule } from './length-range/LengthRange.rule';
import { MaxDimensionRule } from './max-dimension/MaxDimension.rule';
import { NeedSignRule } from './need-sign/NeedSign.rule';
import { PositiveRule } from './positive/Positive.rule';
import { RepeatableRangeRule } from './repeatable-range/RepeatableRange.rule';
import { RequiredRule } from './required/Required.rule';
import { TextFormatRule } from './text-format/TextFormat.rule';
import { UniqueFieldRule } from './unique-field-rule/UniqueFieldRule.rule';
import { ValueRangeRule } from './value-range/ValueRange.rule';

/**
 * Lista di tutte le regole disponibili
 */
export function getAllRuleTypes() {
  return [
    CustomWarningsRule,
    DateRangeRule,
    FileTypeRule,
    IntegerRule,
    ItemRangeRule,
    LengthRangeRule,
    MaxDimensionRule,
    NeedSignRule,
    UniqueFieldRule,
    PositiveRule,
    RepeatableRangeRule,
    RequiredRule,
    TextFormatRule,
    ValueRangeRule,
  ] as const;
}

// type AllRuleTypes = ReturnType<typeof getAllRuleTypes>;

/**
 * Tipizzazione di tutte le opzioni delle regole disponibili
 */
export type IRulesConfig = {
  [K in RuleType]?: Record<string, any>;
};
//   [K in Extract<
//     keyof AllRuleTypes,
//     `${number}`
//   > as AllRuleTypes[K]['type']]?: AllRuleTypes[K]['__optionsType'];
// };
